// src/firebase/init.js
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// For debugging - log environment variables
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('API Key available:', process.env.REACT_APP_FIREBASE_API_KEY ? 'Yes' : 'No');
console.log('reCAPTCHA site key available:', process.env.REACT_APP_RECAPTCHA_SITE_KEY ? 'Yes' : 'No');
console.log('App Check debug token available:', process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN ? 'Yes' : 'No');


// Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
};

// Log the config being used
console.log('Using Firebase configuration:', {
    apiKey: firebaseConfig.apiKey ? 'SET' : 'NOT SET',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    appId: firebaseConfig.appId
});

// Initialize Firebase with minimal configuration
console.log('Initializing Firebase app for authentication only...');
const app = initializeApp(firebaseConfig);

// Initialize Firebase App Check. In development, this uses a debug token.
try {
    // IMPORTANT: Set the debug token BEFORE initializing App Check in a dev environment.
    // The ReCaptchaV3Provider will automatically detect and use this token.
    if (process.env.NODE_ENV !== 'production') {
        console.log("Setting App Check debug token for development.");
        // eslint-disable-next-line
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN || true;
    }

    const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (recaptchaSiteKey) {
        console.log('Initializing Firebase App Check...');
        initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(recaptchaSiteKey),
            isTokenAutoRefreshEnabled: true
        });
        console.log('Firebase App Check initialized successfully.');
    } else {
        console.warn('Firebase App Check not initialized: Missing REACT_APP_RECAPTCHA_SITE_KEY');
    }
} catch (error) {
    console.error('Error initializing Firebase App Check:', error);
}

// Initialize Firebase Authentication only
const auth = getAuth(app);

// Connect to auth emulator in development if needed
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
    console.log('Using Firebase Auth emulator');
    connectAuthEmulator(auth, 'http://localhost:9099');
}

console.log('Firebase Auth initialization complete');

// Export auth only for use in other files
export { auth };
